import { ref } from 'vue';

// Datamuse returns definitions as a flat list of "<pos>\t<text>" strings
const PARTS_OF_SPEECH = {
    n: 'noun',
    v: 'verb',
    adj: 'adjective',
    adv: 'adverb',
    u: 'other'
};

// flat "n\tA representation of..." strings -> the { partOfSpeech, definitions }
// shape the Dictionary component renders, keeping the API's ordering
function toMeanings(defs) {
    const meanings = [];
    for (const entry of defs) {
        const separator = entry.indexOf('\t');
        if (separator === -1) continue;

        const partOfSpeech = PARTS_OF_SPEECH[entry.substring(0, separator)] ?? 'other';
        const definition = entry.substring(separator + 1).trim();
        if (!definition) continue;

        let meaning = meanings.find(m => m.partOfSpeech === partOfSpeech);
        if (!meaning) {
            meaning = { partOfSpeech, definitions: [] };
            meanings.push(meaning);
        }
        meaning.definitions.push({ definition });
    }
    return meanings;
}

export const useDictionary = () => {

    let loading = ref(false);
    async function getDefinition(word) {
        const term = word.trim().toLowerCase();
        if (!term) return '';

        try {
            loading.value = true;
            const response = await fetch(`https://api.datamuse.com/words?sp=${encodeURIComponent(term)}&md=d&max=1`);
            if (!response.ok) {
                return '';
            }

            const results = await response.json();
            // sp= is a spelling pattern, so an unknown word can come back empty or
            // as a near miss - only accept an exact hit that actually has definitions
            const match = results[0];
            if (!match || match.word !== term || !match.defs?.length) {
                return '';
            }

            const meanings = toMeanings(match.defs);
            return meanings.length ? [{ meanings }] : '';
        } catch (e) {
            return '';
        } finally {
            loading.value = false;
        }
    }

    return { getDefinition, loading };
}
